<template>
    <tr >
        <td>{{ filial.Descricao }}</td>
        <td>{{ filial.Ano }}</td>
        <!--
        <td v-if="filial.Liberado">Sim</td>
        <td v-else>Não</td>
        -->
        <td>
            <download-link
            v-if="filial.Liberado"
                :href="url"
                target="_system" 
                class="default-button full icon"
                >Download [PDF] <i class="mdi mdi-cloud-download-outline"></i
            ></download-link>
        </td>
    </tr>
</template>
<script>
import { api_endpoint } from '~/plugins/api';

export default {
    props: ["filial"],
    computed: {
        jwt() {
            return this.$store.state.jwt;
        },
        url() {
            //let endpoint = `${location.origin}${location.pathname}api`;
            let endpoint = api_endpoint
            if (location.origin =='file://' || 'undefined' != typeof window.cordova) {                
                endpoint = window.api_endpoint;
            }
            return `${endpoint}/aluguel/informe-rendimento/${this.filial.Ano}/${this.filial.CodFilial}/${this.filial.CodDimob}/download?jwt=${this.jwt}`;
        }
    }
};
</script>